import React, { useState, useEffect, useRef } from "react";
import { useTheme, styled } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  CardHeader,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { format, isValid } from 'date-fns';
import { useTranslation } from "react-i18next";
//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "entry-of-the-results-of-the-various-assessments-for-the-patients";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const PatientModal = ({ handleClose, open, addPatient, FacilityId, ...props }) => {
  const { t } = useTranslation();

  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  //const { isLoading, error, isError, data, refetch } = useQuery(["patients"],api.getPatients);
  
  const [tabledata, setTabledata] = useState([]); 
  const { isLoading, error, isError, data, refetch } = useQuery(
    ["lab-test-list", FacilityId],
    () =>
      api.getPatientModalList(FacilityId).then((patientlist) => {
        const list = Array.isArray(patientlist) ? patientlist : [];
        setTabledata(list);
        return list;
      }),
    {
      enabled: Boolean(FacilityId),
    }
  );
  
  const [selectedContracts, setSelectedContracts] = useState([]);

  const ContractColumns = [
    { title: "id", field: "id", visible: false },
    { title: "PatientId", field: "PatientId", visible: false },
    { title: t(DispensingLanguage[lan][menukey]['Sl#']),  formatter: "rownum", width:50, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: t(DispensingLanguage[lan][menukey]['Register#']),  field: "idNumber", headerFilter:true  },
    { title: t(DispensingLanguage[lan][menukey]['Last Name']), field: "lastName", headerFilter:true, visible: false   },
    { title: t(DispensingLanguage[lan][menukey]['First Name']), field: "firstName", headerFilter:true, visible: false   },
    { title: t(DispensingLanguage[lan][menukey]['Contact#']), width:150,  field: "contactNumber", headerFilter:true  },
    {
      title: t(DispensingLanguage[lan][menukey]["DoB"]),
      field: "dob",
      width: 140,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        let date = value ? new Date(value) : null;
        if (!date || !isValid(date)) {
          return "";
        }
        return format(date, 'dd/MM/yyyy');
      },
    },
    { title: t(DispensingLanguage[lan][menukey]['Gender']), width:110, field: "GenderTypeId", headerFilter:true  },
   
  

  ];

  let selected = [];
  const ContractDataItems = tabledata?.map((item, index) => { 
    return item;
  });
  const SaveSelectedContracts = () => {
    if(tblRef.table.getSelectedData().length>0)
    setSelectedContracts(tblRef.table.getSelectedData());
  };

  useEffect(() => {
    if (
      Array.isArray(selectedContracts) &&
      selectedContracts.length > 0 &&
      selectedContracts[0]
    ) {
      addPatient(selectedContracts);
    }
 }, [selectedContracts]);

  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('Contract')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('Contract')}
        >
        {t(DispensingLanguage[lan][menukey]['Patient List'])} 
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            onRef={(r) => { tblRef.table = r.current; }}
            options={{
              selectableRowsRangeMode: 'click',
              selectableRows: 1,
             }}
            columns={ContractColumns}
            data={ContractDataItems}
            height="300px"
            layout={"fitColumns"}

          />
        </DialogContent>
        <DialogActions>
          <Button
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={SaveSelectedContracts}
          >
           {t(DispensingLanguage[lan][menukey]['ADD'])}  
          </Button>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={() => handleClose('Contract')}
          >
            {t(DispensingLanguage[lan][menukey]['CANCEL'])}   
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default PatientModal;
